import type { TranslationParams } from '@/context/LanguageContext';
import type { ToolSummary } from '../../api/TraceabilityResponseType';
import { findTool } from '../../utils/toolSummaries';

type Translate = (key: string, params?: TranslationParams) => string;

/** `key.one` / `key.other` (and `key.none` for zero when `withNone`), the count passed as `count`. */
export function countText(t: Translate, key: string, count: number, withNone = false): string {
  if (withNone && count === 0) return t(`${key}.none`);
  return t(`${key}.${count === 1 ? 'one' : 'other'}`, { count });
}

/** Tool page with the reference editor open (`?edit=reference`). */
export function toolReferenceEditPath(toolId: string): string {
  return `/traceability/tools/${encodeURIComponent(toolId)}?edit=reference`;
}

/** The tool a creation form would overwrite, or null. */
export function takenToolId(
  value: string,
  summaries: readonly ToolSummary[] | null
): ToolSummary | null {
  return summaries ? findTool(value, summaries) : null;
}
